import { gql } from '@apollo/client';

export type {
  PostSlackMessage as IPostSlackMessage,
  PostSlackMessageVariables as IPostSlackMessageVariables,
} from './__generated__/PostSlackMessage';

export const POST_SLACK_MESSAGE = gql`
  mutation PostSlackMessage($channel: SlackChannel!, $message: [SlackMessageField!]!) {
    postSlackMessage(channel: $channel, message: $message)
  }
`;
